import React, { useState, useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import api from '../../services/api';

const RECORD_LABELS = {
  leads: 'Leads & Submissions',
  competitors: 'Tracked Competitors',
  ads: 'Swipe File Ads',
  client_users: 'Client Accounts',
  cms_pages: 'CMS Pages',
  plans: 'Subscription Plans',
  case_studies: 'Case Studies',
  insights_articles: 'Insight Articles',
  newsletter_subscribers: 'Newsletter Subscribers'
};

export default function AdminSettings() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getSettingsStatus()
      .then(setStatus)
      .catch(err => setError(err.message || 'Failed to load system status.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8 font-sans">
      <div className="flex justify-between items-center flex-wrap gap-4">
        <div>
          <h2 className="text-xl font-serif font-bold text-white">Database & System Status</h2>
          <p className="text-xs text-zinc-500 mt-1 font-light">Live cPanel MySQL connection and record counts. Read-only - credentials are managed on the server, not from this panel.</p>
        </div>
      </div>

      {error && (
        <div className="p-4 bg-red-950/20 border border-red-900/30 text-red-400 text-xs rounded-xl">{error}</div>
      )}

      {loading ? (
        <p className="text-zinc-500 text-sm">Checking system status...</p>
      ) : status && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Database Status */}
          <div className="bg-zinc-950 border border-zinc-900 rounded-3xl p-8 shadow-2xl space-y-6">
            <div className="flex justify-between items-center border-b border-zinc-900 pb-4">
              <h3 className="text-sm font-bold text-white uppercase tracking-wider">cPanel MySQL Database</h3>
              <span className="bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 text-[9px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
                Connected
              </span>
            </div>

            <div className="space-y-4 text-xs">
              <div className="space-y-1.5">
                <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest">Database Host</label>
                <p className="font-mono text-zinc-300">{status.database.host}</p>
              </div>
              <div className="space-y-1.5">
                <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest">Database Schema Name</label>
                <p className="font-mono text-zinc-300">{status.database.name}</p>
              </div>
              <div className="space-y-1.5">
                <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest">Database Username</label>
                <p className="font-mono text-zinc-300">{status.database.user}</p>
              </div>
              <div className="space-y-1.5">
                <label className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest">PHP Version</label>
                <p className="font-mono text-zinc-300">{status.server.php_version}</p>
              </div>
            </div>
          </div>

          {/* Record Counts */}
          <div className="bg-zinc-950 border border-zinc-900 rounded-3xl p-8 shadow-2xl space-y-6">
            <div className="flex justify-between items-center border-b border-zinc-900 pb-4">
              <h3 className="text-sm font-bold text-white uppercase tracking-wider">Table Record Counts</h3>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {Object.entries(status.record_counts).map(([table, count]) => (
                <div key={table} className="bg-zinc-900/40 p-4 rounded-xl border border-zinc-900">
                  <p className="text-[9px] uppercase font-bold text-zinc-500">{RECORD_LABELS[table] || table}</p>
                  <p className="text-xl font-bold text-white mt-1">{count}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
